module.exports = __webpack_public_path__ + "static/media/company.242fb2b7.png";